module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-d7682ae8677c12b9bafd5277ec8caaf1.svg";